module.exports = {
    'WistiaFormSubmit': require('./wistia-form-submit')
};